import { Request } from 'crono-fe-common/types/request';
import { AttioSettings } from 'crono-fe-common/types/attioSettings';
import client from 'utils/clients/client';
import { ENDPOINTS } from '../../../config/endpoints';

export type AttioVerifyIntegrationResult = {
  data: { isSuccess: boolean; data?: AttioSettings | null };
};

class AttioService {
  private _alreadyRunningVerifyAttioIntegrationCall: Promise<AttioVerifyIntegrationResult> | null =
    null;

  public async verifyAttioIntegration(): Promise<AttioVerifyIntegrationResult> {
    if (this._alreadyRunningVerifyAttioIntegrationCall) {
      return await this._alreadyRunningVerifyAttioIntegrationCall;
    } else {
      this._alreadyRunningVerifyAttioIntegrationCall =
        this._verifyAttioIntegration();
      try {
        const verifyResult =
          await this._alreadyRunningVerifyAttioIntegrationCall;
        return verifyResult;
      } catch {
        return {
          data: {
            isSuccess: false,
          },
        };
      } finally {
        this._alreadyRunningVerifyAttioIntegrationCall = null;
      }
    }
  }

  private async _verifyAttioIntegration(): Promise<AttioVerifyIntegrationResult> {
    const request: Request = {
      url: ENDPOINTS.attio.verify,
      config: {
        method: 'get',
      },
    };

    const result = await client(request);
    return result as AttioVerifyIntegrationResult;
  }
}

// I export a single instance of the service, so that all other files that import
// this file will always import the same instance
export default new AttioService();
